import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import LinkWallet from '../../LinkWallet';
import { StyledUserInfoContainer, StyledUserBalance, StyledProfileIconWrapper, StyledProfileIcon, StyledMenuWrapper } from './Profile.styled';
import { NavItems } from '../../../constants/NavItems';
import ChatImage from "../../../assets/images/chat.png"
import ProfileImage from "../../../assets/images/profile-icon.png"
import ArrowImage from "../../../assets/images/arrow.svg"
import { PlayerContext } from '../../../contexts/playerContext';

interface Props {
    balance: number
    handleDisConnectWallet: () => void
}

const Profile = (props: Props) => {
    const navigate = useNavigate();
    const playerContext = useContext(PlayerContext);

    const [showProfileMenu, setShowProfileMenu] = useState<boolean>(false);

    const handleClickProfile = () => {
        setShowProfileMenu(!showProfileMenu);
    }

    const handleOpenProfilePage = () => {
        navigate('/profile'); // Navigate to the 'About' page
    };

    const handleOpenUsersPage = () => {
        navigate('/players'); // Navigate to the 'About' page
    };

    const handleOpenProfitPage = () => {
        navigate('/profit'); // Navigate to the 'About' page
    };

    const handleOpenTxPage = () => {
        navigate('/transactions'); // Navigate to the 'About' page
    };

    return (
        <StyledUserInfoContainer>
            <StyledUserBalance onClick={handleOpenTxPage}>{props.balance} Tokens</StyledUserBalance>
            <StyledProfileIconWrapper onClick={handleClickProfile}>
                <StyledProfileIcon src={playerContext?.avatar == "" ? ProfileImage : `${process.env.REACT_APP_API_ENDPOINT}${playerContext?.avatar}`} crossOrigin="anonymous" alt="Profile Icon" />
                <img src={ArrowImage} alt="Arrow Image" />
                <StyledMenuWrapper style={{ display: showProfileMenu ? "flex" : "none" }}>
                    <h3 style={{ margin: 0 }} onClick={handleOpenProfilePage}>Profile</h3>
                    {
                        playerContext?.role == 1 && (
                            <h3 style={{ margin: 0 }} onClick={handleOpenUsersPage}>Players</h3>
                        )
                    }
                    {
                        playerContext?.role != 3 && (
                            <h3 style={{ margin: 0 }} onClick={handleOpenProfitPage}>Profit</h3>
                        )
                    }
                    <h3 style={{ margin: 0 }} onClick={props.handleDisConnectWallet}>Disconnect</h3>
                </StyledMenuWrapper>
            </StyledProfileIconWrapper>
        </StyledUserInfoContainer>
    );
}

export default Profile;
